/**
 * Accessibility Widget
 *
 * Dieses Widget ermöglicht es Nutzer*innen, verschiedene Barrierefreiheitsfunktionen per Klick zu aktivieren oder zu deaktivieren.
 * Verfügbare Funktionen:
 * - Kontrastmodus
 * - Links hervorheben
 * - Text vergrößern
 * - Textabstand erhöhen
 * - Zeilenhöhe erhöhen
 * - Blocksatz aktivieren
 * - Bilder ausblenden
 * - Animationen stoppen
 * - Großer Cursor
 *
 * Initialisiert sich bei document.ready.
 *
 * @param {string} selector - Selector für den Toggle-Button, um das Barrierefreiheitsmenü anzuzeigen.
 */
function nc_initAccessibilityWidget(selector) {
  var moduleLogger = LoggerManager.get('accessibility-widget').setPrefix('Selector: ' + selector);
  moduleLogger.trace('INIT START');

  $(document).ready(function () {
    nc_accessibilityWidget(selector);
  });

  moduleLogger.info('INIT ENDE');
}

/**
 * Hauptfunktion für die Barrierefreiheitsfunktionen
 *
 * @param {string} selector - Selector für das Menü-Icon zum Ein-/Ausklappen des Menüs.
 */
function nc_accessibilityWidget(selector) {
  var moduleLogger = LoggerManager.get('accessibility-widget').setPrefix('Selector: ' + selector);
  moduleLogger.trace('SCRIPT START');

  // Menü anzeigen/verstecken beim Klick auf das Widget-Symbol
  $(selector).on('click', function () {
    var $menu = $('#accessibility-widget');
    var isVisible = $menu.toggleClass('is-visible').hasClass('is-visible');
    $menu.attr('aria-hidden', !isVisible);

    // Sowohl den Toggle-Container als auch den Button aktualisieren
    $(this).attr('aria-expanded', isVisible);
    $(this).find('.accessibility-toggle-button').attr('aria-expanded', isVisible);
  });

  // Menü schließen mit separatem Button
  $('.accessibility-close-button').on('click', function () {
    var $menu = $('#accessibility-widget');
    $menu.removeClass('is-visible').attr('aria-hidden', 'true');

    // Sowohl den Toggle-Container als auch den Button zurücksetzen
    $(selector).attr('aria-expanded', 'false');
    $(selector).find('.accessibility-toggle-button').attr('aria-expanded', 'false');
  });

  // Initialzustände aller Features
  var featureState = {
    'contrast': false,
    'highlight-links': false,
    'text-increase': 0,
    'text-spacing': 0,
    'line-height': 0,
    'stop-animations': false,
    'hide-images': false,
    'large-cursor': false,
    'text-align-justify': false
  };

  // Maximale Stufen für inkrementelle Features
  var featureMax = {
    'text-increase': 4,
    'text-spacing': 3,
    'line-height': 3
  };

  // Zuordnung: Feature → Cookie-Name
  var cookieMap = {
    'contrast': 'NC_Theme_ContrastMode',
    'highlight-links': 'NC_Theme_HighlightLinks',
    'stop-animations': 'NC_Theme_StopAnimations',
    'text-increase': 'NC_Theme_TextIncrease',
    'text-spacing': 'NC_Theme_TextSpacing',
    'line-height': 'NC_Theme_LineHeight',
    'hide-images': 'NC_Theme_HideImages',
    'large-cursor': 'NC_Theme_LargeCursor',
    'text-align-justify': 'NC_Theme_JustifyText'
  };

  /**
   * Setzt ein Cookie für ein Feature (entweder bool oder numerisch)
   */
  function setFeatureCookie(feature, value) {
    if (typeof value === 'boolean') {
      $.cookie(cookieMap[feature], value ? 1 : null, { expires: 1, path: '/' });
    } else {
      if (value > 0) {
        $.cookie(cookieMap[feature], value, { expires: 1, path: '/' });
      } else {
        $.cookie(cookieMap[feature], null, { path: '/' });
      }
    }
  }

  /**
   * Aktiviert ein Feature mit entsprechendem Wert (true/false oder Stufe 1-4)
   */
  function applyFeatureState(feature, value) {
    featureState[feature] = value;

    var $button = $('.accessibility-tile[data-feature="' + feature + '"]');

    if (typeof value === 'boolean') {
      // Klassenname für boolsche Features
      var className = 'accessibility__' + feature;
      if (feature === 'contrast') className = 'accessibility__contrast-mode';

      // Klasse auf <html> anwenden
      $('html').toggleClass(className, value);

      // Button visuell und per ARIA aktualisieren
      $button.toggleClass('is-active', value).attr('aria-pressed', value);
    } else {
      // numerische Features (mit Stufen)
      var max = featureMax[feature] || 0;

      // alte Klassen entfernen
      $('html').removeClass(function (_, className) {
        return (className.match(new RegExp('accessibility__' + feature + '-level-\\d+', 'g')) || []).join(' ');
      }).addClass('accessibility__' + feature + '-level-' + value);

      // spezielle Klassennamen für Textgröße zusätzlich anpassen
      if (feature === 'text-increase') {
        $('html').removeClass(function (_, className) {
          return (className.match(/accessibility__font-size-changer-size-\d+/g) || []).join(' ');
        }).addClass('accessibility__font-size-changer-size-' + value);
      }

      // Button aktualisieren (optisch + ARIA)
      $button.toggleClass('is-active', value > 0);
      $button.find('.indicator-bar').removeClass('active').slice(0, value).addClass('active');
      $button.attr('aria-label', $button.find('.tile-text').text() + ', ' + value + ' von ' + max + ' Stufen aktiviert');
    }

    // Cookie speichern
    setFeatureCookie(feature, value);
  }

  /**
   * Klick-Event für alle Funktionskacheln
   */
  $('.accessibility-tile').on('click', function () {
    var $button = $(this);
    var feature = $button.data('feature');

    // Für inkrementelle Features: Stufe hochzählen (mit Rücksetzung bei Überschreitung)
    if (feature in featureMax) {
      featureState[feature] = (featureState[feature] + 1) % (featureMax[feature] + 1);
      applyFeatureState(feature, featureState[feature]);
    } else {
      // Für boolsche Features: true/false umschalten
      featureState[feature] = !featureState[feature];
      applyFeatureState(feature, featureState[feature]);
    }
  });

  /**
   * Zurücksetzen aller Einstellungen auf Standardwerte
   */
  $('#reset-accessibility-settings').on('click', function () {
    // Alle CSS-Klassen von <html> entfernen
    $('html').removeClass(function (_, className) {
      return (className.match(/accessibility__\S+/g) || []).join(' ');
    });

    // Zustände und Cookies zurücksetzen
    for (var key in featureState) {
      featureState[key] = typeof featureState[key] === 'boolean' ? false : 0;
      setFeatureCookie(key, featureState[key]);
    }

    // visuelle Indikatoren zurücksetzen
    $('.indicator-bar').removeClass('active');

    // Buttons zurücksetzen
    $('.accessibility-tile').each(function () {
      var $btn = $(this);
      var feature = $btn.data('feature');
      $btn.removeClass('is-active');

      if (typeof featureState[feature] === 'boolean') {
        $btn.attr('aria-pressed', 'false');
      } else {
        var max = featureMax[feature] || 0;
        $btn.attr('aria-label', $btn.find('.tile-text').text() + ', 0 von ' + max + ' Stufen aktiviert');
      }
    });

    // Fokus vom Button entfernen
    $(this).blur();
  });

  /**
   * Beobachtet Änderungen an der <html>-Klasse für Animationen
   * und pausiert oder aktiviert das Owl Carousel entsprechend
   */
  const $slider = $(".amphi-carousel-inner");
  const observer = new MutationObserver(() => {
    if ($('html').hasClass("accessibility__stop-animations")) {
      $slider.trigger('stop.owl.autoplay');
    } else {
      $slider.trigger('play.owl.autoplay', [10000]);
    }
  });
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

  /**
   * Liest gespeicherte Cookies aus und wendet die entsprechenden Features direkt beim Laden an
   */
  function checkCookiesAndApply() {
    for (const [feature, cookieName] of Object.entries(cookieMap)) {
      const cookieVal = $.cookie(cookieName);
      if (typeof featureState[feature] === 'boolean') {
        if (cookieVal === '1') applyFeatureState(feature, true);
      } else {
        const num = parseInt(cookieVal);
        if (!isNaN(num) && num > 0) applyFeatureState(feature, num);
      }
    }
  }

  checkCookiesAndApply();
  moduleLogger.info('SCRIPT ENDE');
}